import {
  ProductAvailabilityQueryKey,
  ProductAvailabilityRequestBody,
} from './types';

export const productAvailabilityQueryKey = (
  requestBody: ProductAvailabilityRequestBody,
): ProductAvailabilityQueryKey => [
  'products',
  'productAvailability',
  requestBody,
];
